import React, { useEffect, useState, useRef } from 'react';
import { Button, FormControl, Grid2, Input, Typography, } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import InputAdornment from '@mui/material/InputAdornment';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useAuth } from '../../hooks/useAuth';
import useCallbackStatus from '../../hooks/use-callback-status';
import { useNavigate } from "react-router-dom";
import { useFormState } from 'react-use-form-state';
import SingleForm from '../SingleForm';
import validator from 'validator'
import { Email, Person, Phone, VpnKey } from "@mui/icons-material";
import PasswordIcon from '@mui/icons-material/Password';
import {
  NotificationType,
  useNotification,
} from "../../hooks/use-notification";

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(3),
    padding: '10px',
    minWidth: '200px',
  },
  input: {
    margin: theme.spacing(2),
    padding: '10px',
  },
}));

const Login = () => {
  const classes = useStyles();
  const { recaptchaSignIn, forgotPassword, forgotPasswordConfirm: forgotPasswordSubmit, authError, loading, user } = useAuth();

  const navigate = useNavigate();
  const { isPending, isRejected, error, run } = useCallbackStatus();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { set: setNotification } = useNotification();

  // componentdidmount
  useEffect(() => {
    if (user) {
      navigate('/inbox');
    }
  }, [user]);

  // const handleValidation = () => {
  //   let formIsValid = true;
  //   if (inputs) {
  //     let valid = validate(inputs);

  //     if (!valid.isValid) {
  //       formIsValid = false;
  //       let errorArr = [];
  //       errorArr = valid.errors;
  //       setSignInError(prevState => {
  //         return { ...prevState, ...errorArr };
  //       });
  //     } else if (!captchaRef.current.getValue()) {
  //       formIsValid = false;
  //       setSignInError(prevState => {
  //         return { ...prevState, captcha: 'Please complete the reCAPTCHA.' };
  //       });
  //     }
  //   }
  //   return formIsValid;
  // };

  // const handleNewPassword = event => {
  //   event.preventDefault();
  //   if (formState.values.password !== formState.values.password_again) {
  //     setNotification({
  //       type: NotificationType.error,
  //       message: `Passwords don't match`,
  //     });
  //     return;
  //   }

  //   completeNewPassword(resetUser, formState.values.password)
  //     .then(nodata => {
  //       setNotification({
  //         type: NotificationType.success,
  //         message: `Password reset completed. You may now login.`,
  //       });
  //       setDialogOpen(false);
  //     })
  //     .catch(err => {
  //       setNotification({
  //         type: NotificationType.error,
  //         message: err.message,
  //       });
  //     });
  // };

  // const sendConfirmationAgain = event => {
  //   event.preventDefault();
  //   resendSignupVerificationCode(inputs.email.value)
  //     .then(data => {
  //       setNotification({
  //         type: NotificationType.success,
  //         message:
  //           'Please check your email for instructions on how to verify your account.',
  //       });
  //     })
  //     .catch(err => {
  //       setNotification({
  //         type: NotificationType.error,
  //         message:
  //           'Failed to request new verification code. Please see the site administrator.',
  //       });
  //     });    
  // }

  // First step: sign in with credentials.
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validator.isEmail(email)) {
      setNotification({
        type: NotificationType.error,
        message: 'Email address is not valid'
      });
      return;
    }        

    const result = await recaptchaSignIn(email, password);
    if (result) {
      console.log(result);
      if (result.nextStep?.signInStep === "CONFIRM_SIGN_UP") {
        navigate(`/registration/verify?email=${encodeURIComponent(email)}`);
      }

      if (result.isSignedIn) {
        console.log("User signed in successfully:", result);
      }
    }
  };

  // const handleSubmit = event => {
  //   if (event) {
  //     event.preventDefault();
  //     if (handleValidation()) {
  //       run(
  //         login(inputs.email.value, inputs.password.value, captchaRef.current.getValue())
  //           .then(data => {
  //             if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
  //               // show new password dialige
  //               setResetUser(data);
  //               setDialogOpen(true);
  //             } else {
  //               navigate('/inbox');
  //               console.log(user);
  //             }
  //           })
  //           .catch(err => {
  //             // If error is not verified, show dialog and send execute `resendSignUp`
  //             if (err.code === 'UserNotConfirmedException') {
  //               // // setNotification({
  //               // //   type: NotificationType.error,
  //               // //   message:
  //               // //     'Email not verified. Please check your email for instructions on how to verify your account.',
  //               // // });
  //               setUserConfirmRequired(true);
  //               // resendSignupVerificationCode(inputs.email.value)
  //               //   .then(data => {
  //               //     setNotification({
  //               //       type: NotificationType.error,
  //               //       message:
  //               //         'Email not verified. Please check your email for instructions on how to verify your account.',
  //               //     });
  //               //   })
  //               //   .catch(err => {
  //               //     setNotification({
  //               //       type: NotificationType.error,
  //               //       message:
  //               //         'Failed to request new verification code. Please see the site administrator.',
  //               //     });
  //               //   });
  //               return;
  //             } else if (err.code === 'PasswordResetRequiredException') {
  //               resetPassword(inputs.email.value)
  //                 .then(data => {
  //                   console.log(data);
  //                   setNotification({
  //                     type: NotificationType.success,
  //                     message: `Password must be reset. Please check your email for instructions.`,
  //                   });
  //                 })
  //                 .catch(err => {
  //                   console.log(err);
  //                   setNotification({
  //                     type: NotificationType.error,
  //                     message: err.message,
  //                   });
  //                 });
  //             } else if (
  //               err.code === 'NotAuthorizedException' ||
  //               err.code === 'UserNotFoundException'
  //             ) {
  //               //bad password
  //               setNotification({
  //                 type: NotificationType.error,
  //                 message: 'Invalid email or password',
  //               });
  //             } else {
  //               console.log(err);
  //             }
  //           })
  //       );
  //     }
  //   }
  // };

  return <SingleForm onSubmit={handleSubmit}>
    <Input
      placeholder="Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      margin="dense"
      fullWidth
      type="email"
      size="small"
      required
      startAdornment={
        <InputAdornment position="start">
          <Email color="primary" />
        </InputAdornment>
      }
    />
    <Input
      value={password}
      onChange={e => setPassword(e.target.value)}
      placeholder="Enter Password"
      type="password"
      fullWidth
      required
      startAdornment={
        <InputAdornment position="start">
          <PasswordIcon color="primary" />
        </InputAdornment>
      }
    />
    {authError && <p style={{ color: "red", whiteSpace: 'pre-line' }}>{authError}</p>}
    <Grid2 container direction="row" justifyContent="center" spacing={4}>
      <Button
        type="submit"
        variant="outlined"
        color="primary"
        disabled={isPending}
        className={classes.button}
      >
        Sign In
      </Button>
      <Button
        variant="outlined"
        disabled={isPending}
        className={classes.button}
        onClick={() => navigate('/registration')}>
        New User
      </Button>
      <Link to="/reset-password" className="forgot-password">
        Forgot Password
      </Link>
    </Grid2>
  </SingleForm>;
};

export default Login;
